import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from '../images/download-doc.svg';
import downloadpdf from '../images/download-pdf.png';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { IconButton, Grid, Box } from "@mui/material";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import getTypeByLang from '../../common/typeByLang';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import SearchableMultiSelect from '../../common/SearchableMultiSelect';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI } from "../../../utils/datetime.utils";

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      t
    } = this.props;
    const rows = [
      { id: "store", numeric: false, disablePadding: false, label: t("Report.Expired.Store"), padding: '8px', field: 'name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.Expired.Location"), padding: '8', field: 'name' },
      { id: "deliverytype", numeric: false, disablePadding: false, label: t("Report.Expired.DeliverType"), padding: '8px', field: 'name' },
      { id: "binid", numeric: false, disablePadding: false, label: t("Report.Expired.BIN"), padding: '8px', field: 'bin_id' },
      { id: "rxno", numeric: false, disablePadding: false, label: t("Report.Expired.RxHash"), padding: '8px', field: 'rx_no' },
      { id: "fillid", numeric: false, disablePadding: false, label: t("Report.Expired.FillID"), padding: '8px', field: 'fill_id' },
      { id: "prescriptionnumber", numeric: false, disablePadding: false, label: t("Report.Expired.PrescriptionNumber"), padding: '8px', field: 'prescriptionnumber' },
      { id: "OrderId", numeric: false, disablePadding: false, label: t("Report.Expired.OrderID"), padding: '8px', field: 'order_id' },
      { id: "PrescriptionTxnId", numeric: false, disablePadding: false, label: t("Report.Expired.TransactionID"), padding: '8px', field: 'prescription_txn_id' },
      { id: "filldate", numeric: false, disablePadding: false, label: t("Report.Expired.FillDate"), padding: '8px', field: 'fill_date' },
      { id: "stockeddate", numeric: false, disablePadding: false, label: t("Report.Expired.StockDate"), padding: '8px', field: 'stocked_date' },
      { id: "stock_code", numeric: false, disablePadding: false, label: t("Report.Expired.StockCode"), padding: '8px', field: 'stock_code' },
      { id: "pucode", numeric: false, disablePadding: false, label: t("Report.Expired.PUCode"), padding: '8px', field: 'pucode' },
      { id: "firstname", numeric: false, disablePadding: false, label: t("Report.Expired.FirstName"), padding: '8px', field: 'first_name' },
      { id: "lastname", numeric: false, disablePadding: false, label: t("Report.Expired.LastName"), padding: '8px', field: 'last_name' },
      { id: "ndccode", numeric: false, disablePadding: false, label: t("Report.Expired.NDCCode"), padding: '8px', field: 'ndc_code' },
      { id: "drugname", numeric: false, disablePadding: false, label: t("Report.Expired.DrugName"), padding: '8px', field: 'drug_name' },
      { id: "qty", numeric: false, disablePadding: false, label: t("Report.Expired.Qty"), padding: '8px', field: 'qty' },
      { id: "price", numeric: false, disablePadding: false, label: t("Report.Expired.Amount"), padding: '8px', field: 'price' },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'grey' }}
              >
                {[
                  "deliverytype",
                  "binid",
                  "fillid",
                  "prescriptionnumber",
                  "OrderId",
                  "PrescriptionTxnId",
                  "filldate",
                  "ndccode",
                  "qty",
                  "price",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  },
  padding10px: {
    padding: '8px'
  }
  ,
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  }
});

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
  group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_id: [],
      box_id: [],
      fromdate: '',
      todate: '',
      dateRangePreset: '',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      isDataEmpty: true,
      totalRecords: 0,
      isDisabledButton: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      queryId: "",
      groups: [],
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
    this.debouceTimeout = null;
  }

  componentDidMount() {
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const { t } = this.props;
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
    TransactionFilterObj = {
      store_ids: [],
      box_ids: [],
      searchtext: '',
      fromdate: '',
      todate: '',
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'created_on',
      tableName: ''
    }
    this.fetchSuggestions()
    this.BindGrid();
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  // Helper function to properly escape CSV field values
  escapeCsvField(field) {
    if (field === null || field === undefined) {
      return '';
    }
    
    // Convert to string
    const value = String(field);
    
    // Check if field needs to be quoted (contains comma, quote, newline, or carriage return)
    const needsQuoting = /[",\n\r]/.test(value);
    
    if (needsQuoting) {
      // Escape quotes by doubling them and wrap in quotes
      return '"' + value.replace(/"/g, '""') + '"';
    }
    
    return value;
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/ExpiredItemsReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRows = [];
        
        // Add header row
        const headers = [
          'Store',
          'Box',
          'BIN',
          'Rx No',
          'Fill ID',
          'Prescription Number',
          'Order ID',
          'Transaction ID',
          'Fill Date',
          'Stock Date',
          'StockCode',
          'PickUpCode',
          'FirstName',
          'LastName',
          'NDC Code',
          'Drug Name',
          'Qty',
          'Amount',
        ];
        csvRows.push(headers.map(h => this.escapeCsvField(h)).join(','));
        
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              const row = [
                this.escapeCsvField(i.store),
                this.escapeCsvField(i.box),
                this.escapeCsvField(i.binid),
                this.escapeCsvField(i.rxno),
                this.escapeCsvField(i.fillid),
                this.escapeCsvField(i.prescriptionnumber),
                this.escapeCsvField(i.order_id || ''),
                this.escapeCsvField(i.prescription_txn_id || ''),
                this.escapeCsvField(i.filldate ? this.convertToTimeZone(i && i.filldate) : ''),
                this.escapeCsvField(i.stockeddate ? this.convertToTimeZone(i && i.stockeddate) : ''),
                this.escapeCsvField(i.stock_code),
                this.escapeCsvField(i.pucode),
                this.escapeCsvField(i.firstname),
                this.escapeCsvField(i.lastname),
                this.escapeCsvField(i.ndccode),
                this.escapeCsvField(i.drugname),
                this.escapeCsvField(i.qty),
                this.escapeCsvField(i.price ? '$' + parseFloat(i.price).toFixed(2) : '$0.00'),
              ];
              csvRows.push(row.join(','));
            }

            // Use proper newlines for CSV format
            let csvString = csvRows.join('\n');
            
            // Create blob for proper CSV download
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            
            link.setAttribute('href', url);
            link.setAttribute('download', 'StockExpiredItemsReport.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Clean up the URL object
            URL.revokeObjectURL(url);
          }
        }
      });
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['firstname', 'lastname'].includes(field)) {
      tablename = 'customers';
    }
    if (['box'].includes(field)) {
      tablename = 'boxes';
    }
    if (['rxno', 'drugname'].includes(field)) {
      tablename = 'prescription_detail';
    }
    if (['stock_code', 'pucode', 'stockeddate'].includes(field)) {
      tablename = 'prescriptions_master';
    }
    if (['store'].includes(field)) {
      tablename = 'accounts'
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    TransactionFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    const { data } = this.state;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      let BoxesObj = {
        store_ids: store_ids
      }
      this.setState({ loader: true });
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const { t } = this.props;
          let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          this.setState({ chipboxes: [] });
          this.setState({ nboxes: [] });
          this.setState({ boxvalues: boxvalues });
          this.setState({ loader: false });
        });


    }

  }
  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindBoxesbyStoreId(storeids);
    this.BindGrid();
  };
  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.boxvalues[0]];
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (boxid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }

    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleDeleteBoxChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipboxes: [], nboxes: [], box_id: [] });
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindGrid();
      return;
    }
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  handleClearAllBoxes = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipboxes: [], nboxes: [], box_id: [] });
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
    this.setState({ loader: false });
  }
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
    this.setState({ loader: false });
  }
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };


  BindGrid() {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + 'getStockedExpiredItems', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)

    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({ data: uData.results, totalRecords: uData && uData.total });
          setTimeout(() => {
            this.setState({ loader: uData && uData.total && false, isDataEmpty: false, isDisabledButton: false });
          }, 5000)
        } else {
          this.setState({ data: null, loader: false, isDataEmpty: true, isDisabledButton: true });
        }
      });
  }

  exportPDF = () => {
    try {
      this.setState({ loader: true });
      fetch(process.env.REACT_APP_BASEURL + 'printExpiredItems', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(TransactionFilterObj)

      })
        .then((response) => {
          try {
            return response.text()
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          this.setState({ loader: false });
          let x = window.open('', 'title', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=1000,left=145,top=100');
          x.document.write(res);
          x.document.close();
          setTimeout(() => {
            x.print();
            x.close();
          }, 1300)
        })
        .catch((error) => {
          this.setState({ loader: false });
        })
    } catch (error) {
      this.setState({ loader: false });
    }
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const { classes, t } = this.props;
    const { data, totalRecords, queryId, groups } = this.state;
    return (
      <div>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }

        <Box component="div">
          <Grid container spacing={4} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={6} md={6} style={{ paddingLeft: 0 }}>
              <SearchableMultiSelect
                label={t("Report.Expired.StoreDropdown")}
                items={this.state.accountValues || []}
                selectedChips={this.state.chipstores}
                selectedItems={this.state.nstores}
                onChange={this.handleStoreChange}
                onDeleteChip={this.handleDeleteStoreChip}
                onClearAll={this.handleClearAllStores}
                placeholder="Search stores..."
                id="select-multiple-chip-store"
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <SearchableMultiSelect
                label={t("Report.Expired.Box")}
                items={this.state.boxvalues || []}
                selectedChips={this.state.chipboxes}
                selectedItems={this.state.nboxes}
                onChange={this.handleBoxChange}
                onDeleteChip={this.handleDeleteBoxChip}
                onClearAll={this.handleClearAllBoxes}
                placeholder="Search locations..."
                id="select-multiple-chip"
              />
            </Grid>
          </Grid>
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={0} sx={{ mt: '1rem', ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={3} md={3}>
              <FormControl fullWidth>
                <TextField
                  id="idsearchtxt"
                  defaultValue=""
                  value={this.state.searchtxt}
                  label={t("Report.Expired.Search")}
                  onChange={this.onSearchChange}
                  variant="standard"
                />
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3} style={{ paddingLeft: '32px' }}>
              <FormControl
                variant='standard'
                sx={{ m: '16px 0', minWidth: 347 }}
              >
                <InputLabel id='preferred-group-label'>
                  {t('Group.User.GroupControlTitle')}
                </InputLabel>
                <Select
                  labelId='preferred-group-label'
                  id='preferred-group-select-standard'
                  value={queryId}
                  onChange={this.handleInputChange}
                  variant='standard'
                  label={t('Group.User.GroupControlTitle')}
                >
                  {groups.length > 0 &&
                    groups.map((type, index) => (
                      <MenuItem
                        key={index}
                        value={type.id}
                        className={classes.locationType}
                      >
                        {type.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3}>
              <FormControl fullWidth>
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
              <Tooltip key="single-edit" title={t("Report.Expired.ExportCSVTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label={t("Report.Expired.ExportCSVTooltip")}
                  onClick={() => { this.exportCSV() }}
                  disabled={this.state.isDisabledButton}
                >
                  <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
              <Tooltip key="single-edit" title={t("Report.Expired.ExportPDFTooltip")}>
                <IconButton
                  aria-label="ExportPDF"
                  onClick={() => { this.exportPDF() }}
                  disabled={this.state.isDisabledButton}
                >
                  <img alt="download" src={downloadpdf} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>

        <Divider style={{ marginTop: '10px', height: '5px' }} />

        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={TransactionFilterObj.sortOrder}
              orderBy={TransactionFilterObj.sortColumn}
              sortId={this.state.sortId}
              onRequestSort={this.handleRequestSort}
            />
            <TableBody>
              {!data ?
                (<TableRow>
                  <TableCell colSpan={20} style={{ textAlign: "center", padding: '10px 0px' }}>
                    {this.state.isDataEmpty && t("Report.Expired.NoDataFound")}
                  </TableCell>
                </TableRow>)
                : data.length && data.length > 0 &&
                stableSort(data, getSorting(TransactionFilterObj.sortOrder, TransactionFilterObj.sortColumn))
                  .map(n => {
                    return (
                      <TableRow>
                        <TableCell className={classes.padding10px}>{n.store}</TableCell>
                        <TableCell className={classes.padding10px}>{n.box}</TableCell>
                        <TableCell className={classes.padding10px}>{getTypeByLang(n.deliverytype, t)}</TableCell>
                        <TableCell className={classes.padding10px}>{n.binid}</TableCell>
                        <TableCell className={classes.padding10px}>{n.rxno}</TableCell>
                        <TableCell className={classes.padding10px}>{n.fillid}</TableCell>
                        <TableCell className={classes.padding10px}>{n.prescriptionnumber}</TableCell>
                        <TableCell className={classes.padding10px} >{n.order_id || ''}</TableCell>
                        <TableCell className={classes.padding10px} >{n.prescription_txn_id || ''}</TableCell>
                        <TableCell className={classes.padding10px}>{n.filldate ? this.convertToTimeZone(n && n.filldate) : ''}</TableCell>
                        <TableCell className={classes.padding10px}>{n.stockeddate ? this.convertToTimeZone(n && n.stockeddate) : ''}</TableCell>
                        <TableCell className={classes.padding10px}>{n.stock_code}</TableCell>
                        <TableCell className={classes.padding10px}>{n.pucode}</TableCell>
                        <TableCell className={classes.padding10px}>{n.firstname}</TableCell>
                        <TableCell className={classes.padding10px}>{n.lastname}</TableCell>
                        <TableCell className={classes.padding10px}>{n.ndccode}</TableCell>
                        <TableCell className={classes.padding10px}>{n.drugname}</TableCell>
                        <TableCell className={classes.padding10px}>{n.qty}</TableCell>
                        <TableCell className={classes.padding10px}>{n.price}</TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            component="div"
            rowsPerPageOptions={[5, 10, 25]}
            count={totalRecords || 0}
            rowsPerPage={TransactionFilterObj.pageSize}
            page={TransactionFilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/expired-items/index.js